/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FollowOffIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Follow Off',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m7.9 28.9-.758.1a2.9 2.9 0 0 1-3.252-2.506l-.3-2.725 6.516-.845.3 2.725A2.9 2.9 0 0 1 7.9 28.9ZM5.759 1.338C4.083-.615 2.21-.8.886 3.308c-1.96 8.7-.44 12.21 2.323 17.92l6.516-.845c-.7-5.394.643-7.815.362-9.986a17.569 17.569 0 0 0-4.328-9.059ZM13.689 27.25l1.019.171c0-.14-.008-.28-.008-.421a12.305 12.305 0 0 1 9.067-11.87 37.439 37.439 0 0 0-.593-4.6c-1.164-4.16-3.043-4.048-4.792-2.16a17.564 17.564 0 0 0-4.672 8.888c-.364 2.158.885 4.629-.021 9.992ZM15.107 30.147l-1.9-.32-.4 2.659a2.9 2.9 0 0 0 2.38 3.346l.754.127a2.894 2.894 0 0 0 2.146-.483 12.278 12.278 0 0 1-2.98-5.329Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9ZM20 27a6.934 6.934 0 0 1 1.475-4.252l9.777 9.777A6.966 6.966 0 0 1 20 27Zm12.525 4.252-9.777-9.777a6.966 6.966 0 0 1 9.777 9.777Z"
    />
  </svg>`;
};
